module.exports = __webpack_public_path__ + "static/media/sticker-image-1.9a20c8ae.png";